/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'ai-mate.chat-error-banner.description': 'La cronologia della chat viene salvata per un massimo di 30 giorni.',
  'ai-mate.chat-error-banner.title': 'Avvia una nuova chat',
  'ai-mate.chat-error.description': 'Prova a <btn>ricaricare la chat</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Hai raggiunto il numero massimo di richieste. Riprova più tardi.',
  'ai-mate.chat-error.rate-limited-title': 'Troppe richieste',
  'ai-mate.chat-error.rovo-inactive-description':
    'Sembra che Rovo non sia abilitato nel tuo sito. <link>Configura Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo è inattivo',
  'ai-mate.chat-error.title': 'Si è verificato un problema',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Chiedi informazioni ad AI',
  'highlight-actions.rovo-chat-explain-option.text': 'Spiega',
  'highlight-actions.rovo-chat-explain-prompt': 'Spiega: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Consigli sulla chat',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Apri chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Riepiloga',
  'highlight-actions.rovo-chat-summarize-prompt': 'Riepiloga: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Scorri a sinistra',
  'horizontal-scroll-container.scroll-right': 'Scorri a destra',
};
